var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRotateButtonHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 23,
    viewBox: "0 0 20 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8901 4.58C12.0201 4.32 11.0601 4.15 10.0001 4.15C5.21008 4.15 1.33008 8.03 1.33008 12.82C1.33008 17.62 5.21008 21.5 10.0001 21.5C14.7901 21.5 18.6701 17.62 18.6701 12.83C18.6701 11.05 18.1301 9.39 17.2101 8.01M11.2401 1.5L14.1301 4.82L10.7601 7.28",
    stroke: "#00AB4E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotateButtonHover);
export default __webpack_public_path__ + "static/media/Rotate Button Hover.550b39d8ea7d43ed321f11469b9c1b15.svg";
export { ForwardRef as ReactComponent };